import styles from "./styles.module.css";
import { useContext, useState } from "react";
import { AppValue } from "../../contexts/app";
import Sidebar from "./sidebar";
import AppPlan from "./appplan";
import Domain from "./domain";
import Members from "./members";
import Email from "./email";
import Design from "./design";
import { MdInfo } from "react-icons/md";
export default function Page() {
  const {
    plan,
    domain,
    email,
    members = {},
    id,
    palette,
  } = useContext(AppValue);
  const [selected, setSelected] = useState({
    name: "General",
    link: "https://www.notion.so/brevity/c34054a42fe64ab5a55cc782ee1d5e46?v=53aaf0388f1c47afa51c6a9e51fd6371",
  });

  return (
    <div style={{ display: "flex" }} className="page">
      <Sidebar selected={selected} setSelected={setSelected} />
      <div className={styles.content}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div className={styles.sectionTitle}>{selected.name}</div>
          <a href={selected.link}>
            <div className={styles.documentation}>
              <MdInfo size={20} style={{ marginRight: 8 }} />
              Documentation
            </div>
          </a>
        </div>
        {selected.name === "General" && (
          <>
            <Domain plan={plan} domain={domain} />
            <Design palette={palette} />
          </>
        )}
        {selected.name === "Plan/Billing" && (
          <AppPlan members={members} appId={id} plan={plan} />
        )}
        {selected.name === "Email" && <Email email={email} appId={id} />}
      </div>
    </div>
  );
}
